import { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../components/content_overlay_new.css";

function ContentOverlayNew({ heading, text_content }) {
  const overlayRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    // Scroll to top of the overlay content on route change
    if (overlayRef.current) {
      overlayRef.current.scrollTop = 0;
    }
  }, [location.pathname]);

  return (
    <div id="background_image_for_content">
      <div
        id="content-overlay2"
        ref={overlayRef}
     
      >
        <h2>{heading}</h2>
        <div className="row" style={{ display: "flex", gap: "20px" }}>
          {text_content}
        </div>
      </div>
    </div>
  );
}

export default ContentOverlayNew;
